import { CurrencyCode, PlayerBioData } from "@/generated/graphql";
import { ICompositeMetric } from "@/stores/compositeMetric";
import chunkArrayWithPadding from "@/utils/chunkWithPadding";
import { getPlayerCompositeMetrics } from "@/utils/getPlayerCompositeMetrics";

export const getPlayerCompositeMetricsArray = (
  playerBio: PlayerBioData | undefined,
  currencyCode: CurrencyCode | undefined,
  isShowDefaultInCompare: boolean = false,
  isDarkMode: boolean = true,
  isFilterNullMetrics: boolean = true
) => {
  const playerCompositeMetrics = getPlayerCompositeMetrics(
    playerBio
      ? {
          ...playerBio,
          contractExpires: playerBio?.contractExpires
            ? new Date(playerBio?.contractExpires).toISOString()
            : null,
        }
      : playerBio,
    currencyCode ?? CurrencyCode.Eur,
    false,
    isShowDefaultInCompare,
    isDarkMode,
    [], // Empty array for scoutReports - don't show reports in comparison view,
    isFilterNullMetrics
  );

  return chunkArrayWithPadding<ICompositeMetric>(playerCompositeMetrics, 1).map(
    row => row.filter((metric): metric is ICompositeMetric => metric !== null)
  );
};
